<div class="splash">
    <div class="color-line"></div>
    <div class="splash-title">
        <img src="assets/images/logo.jpg" width="80" height="80" />
        <img src="assets/images/loading-bars.svg" width="64" height="64" />
    </div>
</div>